module.exports = __webpack_public_path__ + "static/trees-3.2-59d19a0698f80d0c0725f885aa0cd867.png";